//@flow
import { gql, graphql } from "react-apollo"

export const GetAttractLoopsQuery = gql`
  query GetAttractLoops($query: String!) {
    attractLoops(searchQuery: $query) {
      id
      title
    }
  }
`

const withAttractLoops = graphql(GetAttractLoopsQuery, {
  name: "attractLoops",
  options: ({ searchName }) => ({ variables: { query: searchName } })
})

export default withAttractLoops



// WEBPACK FOOTER //
// ./src/AttractLoops/queries/withAttractLoops.js